module.exports = __webpack_public_path__ + "static/media/cross.button.f0f32389.svg";